// <s-size-guide> turns the size guide's foot-length input into live growth allowance per size row.
// Rows carry data-size-measure (inner length in mm); their [data-size-growth] cell shows measure − foot length.
// Rows with 10–15 mm of room (the recommended growing room) get data-recommended="true".
class SizeGuide extends HTMLElement {
  #controller = null;

  connectedCallback() {
    const input = this.querySelector('[data-foot-length]');
    if (!input) return;
    this.#controller = new AbortController();
    input.addEventListener('input', () => this.#update(input.value), { signal: this.#controller.signal });
    this.#update(input.value);
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #update(raw) {
    const foot = Number.parseInt(raw, 10);
    const valid = Number.isFinite(foot) && foot > 0;
    const { awaiting = '', tooSmall = '', growth = '%mm%' } = this.dataset;
    this.querySelectorAll('[data-size-measure]').forEach((row) => {
      const cell = row.querySelector('[data-size-growth]');
      const measure = Number.parseInt(row.dataset.sizeMeasure, 10);
      if (!cell) return;
      if (!Number.isFinite(measure)) {
        cell.textContent = '–';
        row.dataset.recommended = 'false';
        return;
      }
      if (!valid) {
        cell.textContent = awaiting;
        row.dataset.recommended = 'false';
        return;
      }
      const diff = measure - foot;
      cell.textContent = diff < 0 ? tooSmall : growth.replace('%mm%', String(diff));
      row.dataset.recommended = String(diff >= 10 && diff <= 15);
    });
  }
}

if (!customElements.get('s-size-guide')) customElements.define('s-size-guide', SizeGuide);
